import React, { Component, PropTypes } from 'react';
import {reduxForm} from "redux-form";
import {GetAdminOne, EditAdmin, AddAdmin, DelAdmin} from '../../actions/index';
import {Link} from 'react-router';


class AdminEdit extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.renderPass = this.renderPass.bind(this);
        this.delAdmin = this.delAdmin.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        if(this.props.params.id){
            this.props.GetAdminOne(this.props.params.id, token)
        }
    }
    delAdmin(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelAdmin(this.props.params.id, token).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.context.router.push('/admins');
            }
        });
    }
    delAdminOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        $('#DelAdmin').modal('show');
    }
    closeModal(){
        $('#DelAdmin').modal('hide');
        this.props.admins.admin_one = {};
    }
    SubmitForm(props){
        let token = localStorage.getItem('id_token_admin');
        if(this.props.params.id){
            this.props.EditAdmin(this.props.params.id, props, token).then((response)=>{
                if(response.payload.status == 200){
                    this.context.router.push('/admins');
                }
            });
        }else{
            this.props.AddAdmin(token, props).then((response)=>{
                if(response.payload.status == 201){
                    this.context.router.push('/admins');
                }
            });
        }
    }
    renderPass(){
        const chars = "abcdefghijklmnopqrstuvwxyz1234567890";
        let pass = "";
        for (let x = 0; x < 9; x++) {
            let i = Math.floor(Math.random() * chars.length);
            pass += chars.charAt(i);
        }
        this.props.fields.password.onChange(pass);
    }
    componentWillUnmount(){
        this.props.admins.admin_one = {};
    }
    render() {
        const { fields: {
            first_name,
            email,
            password,
            last_name}, handleSubmit} = this.props;
        return (
            <div className="dashboard-wrapper">
                {this.props.params.id ? <p className="dashboard-title">{this.props.admins.admin_one.first_name} {this.props.admins.admin_one.last_name}</p> : <p className="dashboard-title">Add Admin</p>}
                <form  onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className="block-4-8-title">
                                <p><span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span>Info</p>
                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="first_name">First Name</label>
                                </div>
                                <div className={ first_name.touched && !first_name.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                    <input type="text"
                                           placeholder="First Name"
                                           className="form-control"
                                           name="first_name"
                                           id="first_name"
                                        {...first_name}
                                    />
                                </div>
                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="last_name">Last Name</label>
                                </div>
                                <div className={ last_name.touched && !last_name.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                    <input type="text"
                                           placeholder="Last Name"
                                           className="form-control"
                                           name="last_name"
                                           id="last_name"
                                        {...last_name}
                                    />
                                </div>
                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="email">Email</label>
                                </div>
                                <div className={ email.touched && !email.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                    <input type="text"
                                           placeholder="Email"
                                           className="form-control"
                                           name="email"
                                           id="email"
                                        {...email}
                                    />
                                </div>
                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="password">Password</label>
                                </div>
                                <div className={ password.touched && !password.valid ? 'col-md-2 has-error' : 'col-md-2'}>
                                    <input type="text"
                                           placeholder="Password"
                                           className="form-control"
                                           name="password"
                                           id="password"
                                           disabled
                                        {...password}
                                    />

                                </div>
                                <div className="col-md-2">
                                    <button type="button" onClick={this.renderPass} className="btn btn-primary">Generate new password</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block clearfix">
                            <div className="col-md-12 text-center button-group">
                                <Link to={"admins"} className="btn btn-default">Back</Link>
                                {this.props.params.id ? <button onClick={this.delAdminOpenModal} type="button" className="btn btn-danger">Delete</button> : ""}
                                <button type="submit" className="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </form>

                <div className="modal fade" id="DelAdmin" tabIndex="-1" role="dialog" aria-labelledby="DelAdminLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelAdmin"></span>
                                <p>Do you really want to delete admin {this.props.admins.admin_one ? <span>{this.props.admins.admin_one.first_name} {this.props.admins.admin_one.last_name}</span> : ""}?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delAdmin} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

function validate(values) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const errors = {};
    if(!values.first_name){
        errors.first_name = 'Enter a title'
    }
    if(!values.last_name){
        errors.last_name = 'Enter a title'
    }
    if(!values.email || (values.email && !re.test(values.email))){
        errors.email = 'Enter a title'
    }
    if(!values.password){
        errors.password = 'Enter a title'
    }
    return errors;
}

function  mapStateToProps(state) {
    return{
        admins: state.admins,
        initialValues: {
            first_name: state.admins.admin_one.first_name || '',
            last_name: state.admins.admin_one.last_name || '',
            email: state.admins.admin_one.email || '',
            password: state.admins.admin_one.password || ''
        }
    }
}
export default reduxForm({
    form: 'Edit Admin',
    fields: ['first_name', 'last_name', 'email', 'password'],
    validate
}, mapStateToProps, {GetAdminOne, EditAdmin, AddAdmin, DelAdmin})(AdminEdit);



// WEBPACK FOOTER //
// ./src/components/admin/adminsEdit.js